import { render, staticRenderFns } from "./MyCollection.vue?vue&type=template&id=b72d8a60&scoped=true"
import script from "./MyCollection.vue?vue&type=script&lang=js"
export * from "./MyCollection.vue?vue&type=script&lang=js"
import style0 from "./MyCollection.vue?vue&type=style&index=0&id=b72d8a60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72d8a60",
  null
  
)

export default component.exports